import { ClassesAction } from '../types/ClassesAction';
import ClassesData from '../types/ClassesData';

interface ClassesState {
	list: ClassesData[],
	error: string | null,
};

const initialState: ClassesState = {
	list: [],
	error: null,
};

const classesReducers = (state = initialState, action: ClassesAction) => {
	switch (action.type) {
		case 'CLASSES_SUCCESS': {
			return { ...state, list: action.data }
		}
		case 'CLASSES_FAILED': {
			return { ...state, error: action.error }
		}
		default:
			return state;
	}
}


export default classesReducers;